import React, { useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { GuidelinesContent } from "@/components/GuidelinesContent";

export default function GuidelinesGate() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const open = !!user && !user.guidelines_accepted;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/users/me/accept-guidelines");
      await refresh();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent
        data-testid="guidelines-gate"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="bg-card border-border rounded-2xl max-w-lg max-h-[90vh] overflow-y-auto [&>button]:hidden"
      >
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-[#C084FC]" />Our Community Guidelines</DialogTitle>
          <DialogDescription>Xealth is built to be a healthy, trustworthy place. Please read and agree to continue.</DialogDescription>
        </DialogHeader>
        <GuidelinesContent compact />
        <div>
          <Button data-testid="guidelines-accept-btn" onClick={accept} disabled={busy} className="w-full rounded-xl bg-[#6C0BA9] hover:bg-[#8012C6] text-white">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "I agree to the Community Guidelines"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
